import { downgradeComponent } from '@angular/upgrade/static';
import * as angular from 'angular';
import { AutoGradedJustificationComponent } from './auto-graded-justification.component';

export const ngxAutoGradedJustificationModule = angular.module('ngxAutoGradedJustificationModule', [])
	.directive(
		'ngxAutoGradedJustification',
		downgradeComponent({
			component: AutoGradedJustificationComponent,
			inputs: ['element', 'justification', 'editable', 'isInstructor']
		})
	)
	.name;
